/* LAMORE Studio — reveals, header state, feature explorer. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('ls-js');

  function initRise() {
    var els = document.querySelectorAll('[data-rise]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHeader() {
    var ticking = false;
    function update() {
      document.documentElement.classList.toggle('ls-scrolled', window.scrollY > 8);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function initExplore(root) {
    if (root.dataset.lsReady) return;
    root.dataset.lsReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ls-tab]'));
    var panels = root.querySelectorAll('[data-ls-panel]');
    var counter = root.querySelector('[data-ls-current]');
    function select(i, focus) {
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.closest('.ls-feature').classList.toggle('is-active', on);
      });
      panels.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
      if (counter) counter.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowDown' || k === 'ArrowRight') n = (i + 1) % tabs.length;
        if (k === 'ArrowUp' || k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (k === 'Home') n = 0;
        if (k === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });
  }

  function init() {
    initRise();
    document.querySelectorAll('[data-ls-explore]').forEach(initExplore);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initHeader(); });
  else { init(); initHeader(); }
  document.addEventListener('shopify:section:load', init);
})();
